import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

import { useOccasionContext, useCocktailContext } from '@hooks';
import PrimaryButton from '@components/PrimaryButton';
import SecondaryButton from '@components/SecondaryButton';
import { HeaderLayout } from '@layouts';
import { ROUTES } from '@constants';
import { getTasteMap } from '@utils';

import buttonsTextList from './buttonsTextList';
import { useStyles } from './styles';

function OccasionScreen() {
  const [isDisabledButton, setDisabledbutton] = useState(true);
  const [, setQuestionAnswered] = useState(false);
  const { answer, setAnswer } = useOccasionContext();
  const { fetchCocktailsRecommendation } = useCocktailContext();

  const { t } = useTranslation(['occasionScreen', 'button']);
  const history = useHistory();
  const classes = useStyles();

  const toggleDisableButton = () => {
    if (isDisabledButton) {
      setDisabledbutton(false);
    }
  };

  const handleClick = answer => {
    setQuestionAnswered(true);
    setAnswer(answer);
    toggleDisableButton();
  };

  const failedRedirecting = () => {
    history.push(ROUTES.ERROR_SCREEN, {
      from: ROUTES.SLIDER_SCREEN,
    });
  };

  const successfulRedirecting = () => {
    history.push(ROUTES.ADVICE_SCREEN, {
      from: ROUTES.SLIDER_SCREEN,
    });
  };

  const sendFlavoursPreferences = async () => {
    const flavoursList = JSON.parse(sessionStorage.getItem('flavours'));
    const flavoursAnswer = JSON.parse(sessionStorage.getItem('flavourAnswer'));
    const occasionAnswer = JSON.parse(sessionStorage.getItem('occasionAnswer'));

    const choosenTasteMapByUser = getTasteMap(flavoursList, 'title', 'value');

    const isRecommendationReceived = await fetchCocktailsRecommendation({
      boozy: choosenTasteMapByUser.boozy,
      sweet: choosenTasteMapByUser.citrus,
      sour: choosenTasteMapByUser.sweetness,
      bitter: flavoursAnswer === 'yes' ? 1 : 0,
      occasion: occasionAnswer,
    });

    if (isRecommendationReceived) return successfulRedirecting();
    failedRedirecting();
  };

  return (
    <HeaderLayout title={t('title')}>
      <div className={classes.container}>
        {buttonsTextList.map(button => {
          return (
            <Box key={button.action}>
              <Box className={classes.buttonGroup}>
                <SecondaryButton
                  leftButton
                  lightButton
                  actionButton={button.action}
                  questionAnswered={answer === button.action}
                  answer={answer}
                  textButton={button.text}
                  handleClick={handleClick}
                />
              </Box>
            </Box>
          );
        })}
      </div>
      <PrimaryButton
        text={t('Show my cocktail')}
        isDisabledButton={isDisabledButton}
        handleClick={sendFlavoursPreferences}
      />
    </HeaderLayout>
  );
}

export default OccasionScreen;
